import { createFileRoute } from '@tanstack/react-router';
import { QuotesPage } from '../../features/rates';

export const Route = createFileRoute('/portal/rates/quotes/')({ component: QuotesPage });
